var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLandingIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 278.87 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#edf0f3;}.cls-2{fill:#591914;}.cls-3{fill:#e0d9b6;}.cls-4{fill:#211d50;}.cls-5{fill:#601302;}.cls-6{fill:#6f81a6;}.cls-7{fill:#999;}.cls-8{fill:#f2b90c;}.cls-9{fill:#1d1b22;}.cls-10{fill:#fc7575;}.cls-11{fill:#ea5353;}.cls-12{fill:#fd5e5a;}.cls-13{fill:#ee66b2;}.cls-14{fill:#4239a0;}.cls-15{fill:#393644;}.cls-16{fill:#fff7cf;}.cls-17{fill:#31003d;}.cls-18{fill:#4f005e;}.cls-19{fill:#fff;}.cls-20{fill:#42004a;}.cls-21{fill:#6a0084;}.cls-22{fill:#4c5063;}.cls-23{fill:#464f7c;}.cls-24{fill:#5d69a5;}.cls-25{fill:#bf2604;}.cls-26{fill:#3f1817;}.cls-27{fill:#381a3f;}.cls-28{fill:#653870;}.cls-29{fill:#172866;}.cls-30{fill:#2f499f;}.cls-31{fill:#b65f2e;}.cls-32{fill:#f7931e;}.cls-33{fill:#b96e16;}.cls-34{fill:#f8e000;}.cls-35{fill:#c20095;}.cls-36{fill:#6e0054;}.cls-37{fill:#8c251c;}.cls-38{fill:#d6e9fa;}.cls-39{fill:#99c8f2;}.cls-40{fill:#220d58;}.cls-41{fill:#2d1175;}.cls-42{fill:#53617d;}.cls-43{fill:#b9cbf0;}.cls-44{fill:#ad7435;}.cls-45{fill:#825728;}.cls-46{fill:#6861b3;}.cls-47{fill:#e0d59d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-1",
    d: "M0,237.17S45.45,142,129,120.08c44.36-11.64,63.14-59.91,97.05-67.22s44.95,57.78,50.87,107.7-3.19,78.37-3.19,78.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-2",
    d: "M146.41,132.58s36,6.56,43,1c0,0-6.84-41.15-6.84-43.72s-4.83-27.67-4.83-27.67L165.44,61l-12.13,48Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    className: "cls-3",
    x: 64.08,
    y: 11.4,
    width: 6.15,
    height: 224.58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-3",
    x: 120.31,
    y: 11.4,
    width: 6.15,
    height: 224.58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    className: "cls-3",
    x: 67.16,
    y: 86.84,
    width: 56.23,
    height: 4.51
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    className: "cls-3",
    x: 67.16,
    y: 166.14,
    width: 56.23,
    height: 6.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-3",
    d: "M69.06,237.13l-3.8-3.39,54.91-61.61L64.25,88.85l57.1-76.8,4.08,3-55.15,74,56.18,82.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-4",
    d: "M231.91,86c-1.86,3.33-4.84,24.08-5.85,24.08-.62,0-3.82-4.9-6.38-9.18-1.6.55-2.81,1.8-4.42,2,1.94,5.08,4.31,10.92,5.37,12,1.93,1.93,5.1,4.9,9.47,2.32s5.18-15.09,5.18-15.09l.56-20S233.85,82.5,231.91,86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-5",
    d: "M157.82,65.84l-4.51-2s-23.5,18.85-27.1,19.83l2.86,8s16.24-2.28,25.86-10.75S157.82,65.84,157.82,65.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-6",
    d: "M125.28,71.73s.52-.52-.82-1.15a5.35,5.35,0,0,0-2.62-.45c-1,.07-2.47.28-2.88.9,0,.07,2.9,18.22,2.9,18.22h7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-7",
    d: "M262.66,239.93c0,3.56-45,16.19-117.5,6.45-64.32-8.64-117.5-2.89-117.5-6.45s52.6-6.45,117.5-6.45S262.66,236.37,262.66,239.93Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-2",
    d: "M251.08,110.24c.43-1.7,1.94-28,.34-28.32S251.08,110.24,251.08,110.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-8",
    d: "M235.84,82.08s-3.51,8.46-7.13,13.24-3.79,44.6-1.74,44.6,6.67-1.66,6.67-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-9",
    d: "M250.67,238.6l-.1,6.5.72,0,.93-7.41Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    className: "cls-10",
    d: "M245.67,181.47s.77,10.16,2,13.19-1,43.16-2,46.4a9.79,9.79,0,0,1-.88,1.92c-1.15,2-1.42,2.37.13,2.38,2,0,3.72-.38,4.11-1.19.67-1.4,1.25-6.24,2.61-6.23a5.67,5.67,0,0,0,.7-2.76c-.35-1.42-1.32-.69-1.31-2.68s6.59-32.16,5.56-36.55-1.76-4.92-1.75-10.15S245.67,181.47,245.67,181.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    className: "cls-10",
    d: "M241.18,170.83s-7.41,14.12-6.94,18.3,2,7.56.7,13.27-12,26.41-12.22,30.2c-.11,1.6.38,1.74.38,1.74,0,2.75-.88,5.7-1.45,6.27-.74.73-1.56,4.35-2.26,4.35s-6.59.62-6.59.62c-.15-1.34,1.65-.26,2.7-3s1.7-7,3-12.6,6.85-31.37,6.87-37.3-.52-5.95.4-9.85,4.36-11.2,4.36-11.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    className: "cls-11",
    d: "M234.24,189.13c-.47-4.18,6.94-18.3,6.94-18.3l-11,.76s-3.44,7.3-4.36,11.2a17.45,17.45,0,0,0-.46,6.19c2.11.45,5.38,1.11,9.13,1.72C234.38,190.19,234.3,189.67,234.24,189.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    className: "cls-12",
    d: "M254.82,185.8c0-5.22-9.15-4.33-9.15-4.33s.49,6.48,1.32,10.63a41.25,41.25,0,0,0,8.46-.31A20.81,20.81,0,0,1,254.82,185.8Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    className: "cls-13",
    d: "M235.84,82.08s3.43-2.64,15,0c.32.07.61,12.69.61,12.69s-5.4,21.11-4.37,26.37c0,0-6.17,5.2-15.36.68,0,0,1.2-16.58.36-20.27s-2.51-7-.14-10.87A43.72,43.72,0,0,0,235.84,82.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    className: "cls-14",
    d: "M228.94,147.05c1-4.74,2.83-25.25,2.83-25.25s1.2-16.58.36-20.27-2.51-7-.14-10.87a43.11,43.11,0,0,0,3.84-8.58s3.44-2.64,15.06,0c.32.07.61,12.69.61,12.69s-5.4,21.11-4.37,26.37c0,0,6.17,10.08,7.58,15.62s.39,48.63.39,48.63c-6,2.09-30.47,0-30.47,0S228,151.79,228.94,147.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    className: "cls-15",
    d: "M244.77,243c0,1.27.06,1.55,2,1.13,1.38-.64,3.8-7,4.41-10.63a2.65,2.65,0,0,1,1.71,1.75c.23.89-.86,9.91-.86,9.91l-.73,0,.45-6.55c-1.36,0-1.74,5.31-2.4,6.72-.39.81-3.48.68-5.47.67C242.31,246,243.62,245,244.77,243Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    className: "cls-15",
    d: "M214.65,243.81c-1.38,1.29-3.49,1-3.36,2.11,0,0,7.62-.31,8.31-.31s1.3-4.28,2-5,.26,5,.26,5h.75a63,63,0,0,1,1.23-8.21,2.5,2.5,0,0,0-.79-3.07C220.79,238.71,220.41,244.86,214.65,243.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    className: "cls-8",
    d: "M245.93,80.9s-5.53,45.43-3.45,50.35,6.9,14.28,15.45,11.73l-6.44-44.55-.07-16.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    className: "cls-16",
    d: "M244.77,91.07h6.69v-2.9h-6.36C245,89.07,244.88,90.05,244.77,91.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    className: "cls-16",
    d: "M243.8,100.41h8l-.28-2V97.5h-7.4C244,98.46,243.89,99.43,243.8,100.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    className: "cls-17",
    d: "M234.35,54.82s1.1-2.81,7.73-2.81,8,6.54,7.14,8.16.6,4.88,2.13,5.33,5.36,2.55,3.29,4.62,1.64,1.95,1.64,3.82-1.13,3.1-3.74,3.44S234.35,54.82,234.35,54.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    className: "cls-10",
    d: "M235.85,72.9s1,8,1,13.2c0,.8,4.11,0,4.91-.62,1.27-.93,2.18-1.55,2.4-3.29.15-1.17-3.26-12.63-3.26-12.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    className: "cls-12",
    d: "M241.34,71.21c-.75,2.46-2.1,5.15-4.63,6l-.4.11c-.23-2.56-.46-4.46-.46-4.46l5-3.34S241.05,70.21,241.34,71.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    className: "cls-10",
    d: "M233.19,56.27a5.67,5.67,0,0,0-2.36,3c-.66,2.07.38,4.67.1,6.46s1.71,10.84,6.17,9.48,5.13-7.91,5.36-9.36-1-6.8-3.27-8.37S233.19,56.27,233.19,56.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    className: "cls-12",
    d: "M230.83,59.29a5.67,5.67,0,0,1,2.36-3s3.72-.33,6,1.23,3.5,6.91,3.27,8.37c-.17,1.11-.61,5.19-2.8,7.66-.23-2.53,1.58-6.29.83-9.9a5,5,0,0,1-1.68.21c-2.06-.11.8-3-1.07-5.9-1.15-.87-1.19-1-2-1.16-.24,2.33-2.5,6.39-4.83,8.72C231.12,63.72,230.2,61.26,230.83,59.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    className: "cls-18",
    d: "M234,65.33a29.21,29.21,0,0,1-.71,3.59,2.24,2.24,0,0,0,1.26.32,2.07,2.07,0,0,1-1.48-.22A29.3,29.3,0,0,1,234,65.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    className: "cls-18",
    d: "M236.18,63.67a4.44,4.44,0,0,1,1.91-.62c1,0,2.28,1.22,2.28,1.22a5.37,5.37,0,0,0-2.1-.93,3.81,3.81,0,0,0-1.36.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    className: "cls-18",
    d: "M233.78,63.51a3.56,3.56,0,0,0-1.52-.9c-.83-.19-2,.86-2,.86s1.29-.75,1.85-.6a3.19,3.19,0,0,1,1.08.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    className: "cls-19",
    d: "M236.56,71.08c-2.21.63-3,.51-3.73.29A2.92,2.92,0,0,0,236.56,71.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-18",
    d: "M236.7,65.19a.57.57,0,1,0,1.1-.33.58.58,0,0,0-.64-.4A.61.61,0,0,0,236.7,65.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-20",
    d: "M239.27,65.5c-2.1-2.16-2.94-.58-3.64-.47.57,0,1.22-.58,1.85-.41A9,9,0,0,1,239.27,65.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-18",
    d: "M231.93,65.06c0,.35.29.6.53.56a.61.61,0,0,0,.35-.72c-.06-.35-.3-.6-.54-.56S231.87,64.71,231.93,65.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    className: "cls-20",
    d: "M233.71,65.3c-1.67-2-2.44-.44-3-.3.47,0,1-.62,1.56-.49A6.71,6.71,0,0,1,233.71,65.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    className: "cls-12",
    d: "M236.57,68.57a1.32,1.32,0,0,0,1.62.86c.8-.13,1.37-.73,1.27-1.33a1.33,1.33,0,0,0-1.62-.86C237,67.37,236.47,68,236.57,68.57Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    className: "cls-18",
    d: "M234.35,54.82A6.35,6.35,0,0,0,230,55.91c-2,1.45-2.19,7.2-1.15,8.4s-3.72,2.76-1.15,3C231.39,67.57,236.6,55.42,234.35,54.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    className: "cls-21",
    d: "M233.64,55.62c-3.46-.11-5.63,2.68-4.72,5.57a1.71,1.71,0,0,0,.9,1.16l.2-.7c-.19,0-.43-.5-.5-.67C228.5,58.47,230.35,55.77,233.64,55.62Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    className: "cls-22",
    d: "M180.64,227.55l.74,4s-1.9,6.18-4.78,9.06-9.06,3.06-9.06.61,6.45-10,6.45-13S180.64,227.55,180.64,227.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    className: "cls-22",
    d: "M161,228.29l1.1,7.47h-19s.61-1.84,6.12-2.94,5.82-3,5.82-3l-.43-4.82,5-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    className: "cls-23",
    d: "M169,142.76,157.8,182.15l4.1,47.49h-7.23l-9.92-50.22,9.92-57.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    className: "cls-24",
    d: "M154.68,120.39l6.67,22.4s10.23,33.44,11.88,52.8,0,32.58,0,32.58l9.13,1.47s5.26-40.18,3.3-53.65.44-46.3.44-46.3l-3.74-9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    className: "cls-25",
    d: "M157.38,106.77l-4.07-42.94a51.07,51.07,0,0,1,22.17-1C186.89,65.13,190.55,69,190.55,69s-9.21,34.39-9.21,39.28,2.2,15,2.2,15l-28.86-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    className: "cls-8",
    d: "M177.69,62.21s-3.12,39.76-3.12,52.35,3.5,20.32,14.79,19L186.81,96s-1.16-22.66,3.84-27.66C190.65,68.33,182.72,62,177.69,62.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    className: "cls-8",
    d: "M165.44,61s-2.71,67.52-8.56,69.7a27.51,27.51,0,0,1-10.47,1.85s8.33-56.47,6.9-68.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    className: "cls-16",
    d: "M176.92,72.46c-.09,1.15-.17,2.37-.26,3.63l10.87,1c.19-1.27.43-2.48.71-3.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    className: "cls-16",
    d: "M164.73,75c.08-1.27.15-2.49.2-3.63l-11.51-1c0,1.13-.1,2.35-.18,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    className: "cls-16",
    d: "M176.11,83.94q-.12,1.8-.24,3.63l10.84,1c0-1.15,0-2.38.1-3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    className: "cls-16",
    d: "M164,86.53c.09-1.23.17-2.45.25-3.63l-11.6-1c-.11,1.18-.22,2.39-.34,3.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    className: "cls-25",
    d: "M190.26,68.77c7,0,17.28,41.94,15.15,46.5-2.28,4.89-28.14-10.93-28.14-10.93l1.55-8.52s10.71,5.26,11.73,4.24-3.66-16.87-3.66-16.87S188.65,68.77,190.26,68.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    className: "cls-12",
    d: "M216.43,94.9c-.85-2.32.13-5.31-1.29-6.72S214.24,84.7,214,85s-1.49,1.08-.31,2.83.65,1.57.08,1.57-5.08-6.77-5.72-6.12,4.43,6.22,3.84,6.82-1.54-1.5-1.54-1.5L209.81,93l2.54,2s1.3,3.66,2.9,7.85c1.61-.2,2.83-1.45,4.42-2A57.11,57.11,0,0,1,216.43,94.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    className: "cls-10",
    d: "M210.77,87.75s5.1,4.17,4.55,5.41-3.63-2.85-4.21-2.28,2.7,2.21,2.48,3.23-3.18-1.49-3.18-1.49,1.79,1.54,1.79,2.28-1.07.48-2.13-.58-.89-2.86-.89-4.14S210.77,87.75,210.77,87.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-26",
    d: "M173.76,43.61l-11,4.87-1.55-.55.28-2.34,4-3.36,10-4.12,5.48-.68.18.59-.73,1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    className: "cls-27",
    d: "M168.75,56.52c-.23-.15-3.15-7.42-3.15-7.42s-1.95-5.45-.69-6.38,4.25-4.12,6.87-4.18a9.93,9.93,0,0,1,4.62.88c.23.14,1.93,3,1.93,3s-.79-1-1.2,2.62S168.75,56.52,168.75,56.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    className: "cls-10",
    d: "M175.37,56.19c-.31.93-.18,7.56-.42,9.23s-7.77,4.2-7.91-1.79.44-13,.44-13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    className: "cls-12",
    d: "M175.37,56.19h0l-2.62-1.86-5.27-3.74v0s0,.07,0,.13c0,.22-.05.66-.09,1.26h0l0,.39v0c0,.44-.06.94-.09,1.49V54c0,.13,0,.27,0,.4h0c0,.07,0,.14,0,.21v.28c1,3.21,4.68,6.7,7.88,7.11l0-.67A38.47,38.47,0,0,1,175.37,56.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    className: "cls-10",
    d: "M167.18,45.1a11.56,11.56,0,0,0,1.29,10.09c2.3,3.31,5.46,5,7.73,3.35s2.92-12.16,1.28-14.86S168.65,41.45,167.18,45.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    className: "cls-28",
    d: "M167.19,55.16s-.51-3.43-1.83-4.26-1.91-1.35-2.15-2.56-3.15-3.69-2.43-5.68,2.68-1.26,4.42-4.72,3.64-5.38,7.71-4.12,4.64,3.75,4.64,3.75a2.86,2.86,0,0,1,2.9,1.84,3.66,3.66,0,0,1-.4,4.38s.16-2.84-.82-2.64,0,3.32,0,3.32a25.59,25.59,0,0,1-3-3c-1.56-1.85-1.18.32-.72,2.66s-3,.14-4.53-1.56-3.74-.11-4.54,2.3S169.09,51,167.19,55.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    className: "cls-10",
    d: "M167.94,48.86s-1.44-2.45-2.18-1.39-.13,4.25,1.45,4.29S167.94,48.86,167.94,48.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    className: "cls-12",
    d: "M167.13,49s.05-1.42-.72-.95,0,2.75.72,2.71S167.13,49,167.13,49Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    className: "cls-29",
    d: "M175.28,48.38a8.94,8.94,0,0,1,.57,2,5.33,5.33,0,0,1,0,2.25c-.18,0-.64-.1-1.26-.26a11.81,11.81,0,0,1,1.19,0l-.14.1A27.07,27.07,0,0,0,175.28,48.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    className: "cls-30",
    d: "M173.33,48.74a.72.72,0,0,1-.42.89c-.31.06-.63-.23-.71-.66a.7.7,0,0,1,.41-.88C172.93,48,173.25,48.32,173.33,48.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    className: "cls-30",
    d: "M177.64,48.13a.72.72,0,0,1-.42.89c-.31.06-.63-.23-.72-.66a.71.71,0,0,1,.42-.88C177.23,47.41,177.55,47.71,177.64,48.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    className: "cls-29",
    d: "M170.89,47.66a3.07,3.07,0,0,1,1.76-1.38c1.1-.22.77.7.51.76S170.84,47.45,170.89,47.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    className: "cls-29",
    d: "M176.14,45.75s1.3.38,1.55,1c0,0-1.38-.11-1.63-.44a.35.35,0,0,1,0-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    className: "cls-19",
    d: "M171.8,54.22s3.37,1.26,5.19.05c0,0-.51,1.7-1,2C175,56.91,172.63,56.42,171.8,54.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    className: "cls-8",
    d: "M164.63,33.66c0,.08,2.84,7.14,2.8,7.07,2.86-1,6.9-2.23,9.84-3-.49-1.22-1.25-3.12-2.47-3.82-1.64-.94-4.46-2.44-6.7-2.05A7.28,7.28,0,0,0,164.63,33.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    className: "cls-8",
    d: "M164.93,33.4l2.91,7.22c3-1.09,8.49-3,11.58-3.76a11.71,11.71,0,0,0-2.12-3.3,8.61,8.61,0,0,0-4.36-2.28,8.14,8.14,0,0,0-4.43.19,12.6,12.6,0,0,0-3.24,1.67A2.18,2.18,0,0,0,164.93,33.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    className: "cls-31",
    d: "M163.15,34.2l3.42,6.9c.08,0,3.84-1.5,9.26-3-.5-1.84-1.18-3.87-2.77-5.06A6.59,6.59,0,0,0,167.57,32a6.79,6.79,0,0,0-2.3,1.14A10.77,10.77,0,0,0,163.15,34.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    className: "cls-32",
    d: "M160.68,45.6c1.14-3.54,9.61-6,13.4-7-.23-1-.68-3.5-1.63-4.46-3.53-3.55-12.35-.77-13,5.8A18,18,0,0,0,160.68,45.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    className: "cls-33",
    d: "M160.67,45.61h0c1-3.53,9-5.71,12.69-6.78,2-.63,8-2.92,8.51-1.2.17.65-.32,1-1.42,1.79-.17-.24,1.26-1.71-1.22-1.21-4.52.93-11.19,1.73-17,7.55C161,47,162,48,162.79,48.49a2.15,2.15,0,0,1-2.25-2A2.23,2.23,0,0,1,160.67,45.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    className: "cls-34",
    d: "M160.51,45.55c1.35-5.14,18.91-10.38,21.5-9.1,1.1.55.35,1.87-1.56,3,.84-.64,1.11-1,1.21-1.27,1-3.14-15.17,2.66-18.84,5.23a5.18,5.18,0,0,0-2,2.25h0a2.27,2.27,0,0,0-.07,1.41,2,2,0,0,0,.79,1.18C160,47.73,160.51,45.55,160.51,45.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_37",
    "data-name": "Group 37"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    className: "cls-35",
    d: "M18.67,93.55S21,71.85,31.56,63.72c0,0,7,19.28,3.85,22.47s-7.95,9-7.95,9S26.91,95.52,18.67,93.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    className: "cls-6",
    d: "M75.6,126.67l30.08-34.91s2-1.43-3.4-4.3-7.32-1.64-8.78,0c0,0-25.71,38.7-24.4,38.7S75.6,126.67,75.6,126.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    className: "cls-36",
    d: "M67.19,65.21s8.53,38.38,19.51,43.22l-7.3,6.13a42.8,42.8,0,0,1-14.85-16C58.55,87.45,67.19,65.21,67.19,65.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    className: "cls-22",
    d: "M53.59,231.71,52.53,239H71s-.59-1.79-5.95-2.86S59,233,59,233l.75-4.52-4.88-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    className: "cls-23",
    d: "M45.86,148.65,56.75,186.9l-4,46.12h7l9.64-48.77-9.64-55.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    className: "cls-22",
    d: "M34.56,231l-.71,3.92s1.84,6,4.64,8.8,8.8,3,8.8.6S41,234.56,41,231.71,34.56,231,34.56,231Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    className: "cls-24",
    d: "M59.78,126.92,52.25,150s-8.88,31.17-10.49,50a167.22,167.22,0,0,0,0,31.64L32.9,233s-5.12-39-3.21-52.1-.43-45-.43-45l3.64-9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    className: "cls-35",
    d: "M40.47,108.43,29.26,129.65l30.82.53,4.48-18.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    className: "cls-37",
    d: "M42.85,60.76s11.7,3.08,14.89,1.45l.34,19.1L45.59,81Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    className: "cls-35",
    d: "M67.19,65.21s-18.8-3.9-28.65-2.81c-5.43.6-7,1.32-7,1.32l9,52.2s22.38,1.43,22.92.9S66.51,74.52,67.19,65.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    className: "cls-8",
    d: "M42.85,60.76s8.6,49.42.15,56.18a51.53,51.53,0,0,1-15.75,8.92l5.29-36.6s1.54-24.52.16-25.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    className: "cls-8",
    d: "M57.74,62.21s.61,54.21,3.08,58.94,4.86,5.52,4.86,5.52l1.5-61.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    className: "cls-8",
    d: "M57.74,62.21s.61,54.21,3.08,58.94,4.86,5.52,4.86,5.52l1.5-61.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    className: "cls-16",
    d: "M66.88,77.86l.12-5.1H57.91c0,1.59.07,3.3.11,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    className: "cls-16",
    d: "M45.25,77.86c-.2-1.78-.42-3.49-.62-5.1H33.25c0,1.66-.08,3.4-.15,5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    className: "cls-16",
    d: "M66.65,87l.13-5.09H58.12c0,1.66.09,3.36.14,5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    className: "cls-16",
    d: "M46.14,87c-.14-1.72-.29-3.42-.46-5.09H32.94c-.09,2-.19,3.78-.26,5.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    className: "cls-38",
    d: "M100.48,91.4l-28.1,35.27s-5.19-.36-4.12-1.44S93.5,87.46,93.5,87.46,92.25,95.34,100.48,91.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    className: "cls-39",
    d: "M38.36,86.19s-.62,6.91,2.69,10.22,59.25,4.48,64.63-4.65l-30.62,35.8a46.36,46.36,0,0,1-20.59-.9c-11.63-3-19,1.07-24.69-1.08a41.41,41.41,0,0,0-10-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    className: "cls-12",
    d: "M26.73,93.91s3.63,2.86,1,13.34l-4.66,4.85s-8.52-11-4.4-18.55C18.67,93.55,23.68,90.86,26.73,93.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    className: "cls-10",
    d: "M33.53,113.06s-3.89-1.7-4.84-3.76-.07-2.75-.65-3.33-2.87-.13-3.45.46-2.32,1.29-2,3.43-1.82,2.87-1.82,3.86a6.47,6.47,0,0,0,1.49,3.57c.79.79,3.62,1,5.59.34s-2.42-1.88-2.42-1.88,5.19,1,6.09.09-4.48-2.15-4.48-2.15a54.79,54.79,0,0,0,5.82,1C34.16,114.67,33.53,113.06,33.53,113.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    className: "cls-12",
    d: "M88.83,111.7s-2.89-1.68-2.89-.43,1.6,2.1,1.6,2.1-2.15-1.21-2.63-.31,1,1.43,1,1.43-1.68-.28-2.23.27.83,1.81.83,1.81-1.49-.6-1.49,0,1.46,1.74,2.77,1.74,2.81-.06,3.26-1,.83-.71,1.34-1.79S88.83,112.29,88.83,111.7Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    className: "cls-40",
    d: "M44.26,40.55c.72,0,1.69-.09,2.69-.17h0c2.26-.17,4.45-.25,6.47.77-1,1.54.2,3.69.48,5.48-2.94.6-6.47,1.15-9.31,0A17.19,17.19,0,0,1,43,41.34C43.35,41.1,43.77,40.83,44.26,40.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    className: "cls-8",
    d: "M49.71,32.15l.84,7.38c3-.26,7.07-.34,10-.31-.15-1.28-.39-3.26-1.36-4.23-1.3-1.3-3.57-3.44-5.79-3.64A7.06,7.06,0,0,0,49.71,32.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    className: "cls-8",
    d: "M50.05,32l.9,7.55c3.12-.26,8.76-.63,11.87-.6a11.51,11.51,0,0,0-1.15-3.65A8.51,8.51,0,0,0,58.14,32a8.1,8.1,0,0,0-4.23-1,13,13,0,0,0-3.48.75A2.54,2.54,0,0,0,50.05,32Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    className: "cls-31",
    d: "M48.17,32.28l1.46,7.37c.09,0,4-.43,9.49-.43,0-1.86-.12-3.95-1.32-5.48a6.44,6.44,0,0,0-4.9-2.41,6.91,6.91,0,0,0-2.46.49A10.39,10.39,0,0,0,48.17,32.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    className: "cls-32",
    d: "M42.93,42.39c2-3,10.57-3.15,14.41-3.15,0-1,.26-3.47-.39-4.62-2.43-4.24-11.45-3.87-13.74,2.16C42.73,38.08,42.83,40.84,42.93,42.39Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    className: "cls-2",
    d: "M47.44,34.58h0l1.34-.33a.1.1,0,0,0,0-.2l-1.34.34a.09.09,0,0,0-.09.11.09.09,0,0,0,.11.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    className: "cls-2",
    d: "M47.57,35.34h0L48.81,35a.1.1,0,0,0,0-.13.09.09,0,0,0-.11-.06l-1.2.33a.09.09,0,0,0-.07.12.1.1,0,0,0,.09.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_33",
    "data-name": "Group 33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    className: "cls-2",
    d: "M44.53,35.65h0l1.25-.48a.1.1,0,0,0-.08-.19l-1.24.48a.1.1,0,0,0-.05.13A.09.09,0,0,0,44.53,35.65Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_34",
    "data-name": "Group 34"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    className: "cls-2",
    d: "M44.53,36.27h0l1.24-.44a.11.11,0,0,0,.08-.12.1.1,0,0,0-.12-.08s0,0,0,0l-1.24.44a.1.1,0,0,0,0,.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_35",
    "data-name": "Group 35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    className: "cls-2",
    d: "M46.31,35.05a.27.27,0,1,0,.27-.27.27.27,0,0,0-.27.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    className: "cls-10",
    d: "M61.38,41.17a.73.73,0,0,1,.64.45,8.33,8.33,0,0,1,.48,1.54c.68,3.47,1.55,9,1.55,9l-1.55,0a17.55,17.55,0,0,0-1.14,5.2c.06,2.07-3.25.87-5.14.92S50.07,56.89,48.27,51a32.58,32.58,0,0,1-1.6-7.15c2.1-.53,4.22-1.74,6.33-2.19A43.48,43.48,0,0,1,61.38,41.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    className: "cls-10",
    d: "M45,62.56s2.5,9.93,9.46,6.89c1.12-.49,1-10.31,1.16-12.72l-3.46-8h0l-.66-1.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    className: "cls-41",
    d: "M53.09,41.65c-.13,2,1.49,5.2.61,6.78l-1.7.38s-.38-1-1.06-1-.74,5.24-1.85,5.27-3.38-4.35-4.47-6.38c-.11-.2-.22-.45-.35-.73a2.24,2.24,0,0,1,.88-2.41C47.47,42.39,49.69,42.11,53.09,41.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-41",
    d: "M46.88,42.84l-.47.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-41",
    d: "M45.15,43.57a.81.81,0,0,0-.24.17A.81.81,0,0,1,45.15,43.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-41",
    d: "M46,43.17c-.26.11-.53.24-.8.37C45.48,43.41,45.74,43.28,46,43.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-41",
    d: "M44.42,44.42l-.06.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-41",
    d: "M44.6,44.1l-.09.15C44.54,44.19,44.57,44.15,44.6,44.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-41",
    d: "M44.83,43.82l-.14.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-41",
    d: "M44.21,45.75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    className: "cls-41",
    d: "M51.83,41.82l-.43.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    className: "cls-41",
    d: "M47.77,42.57l-.41.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    className: "cls-41",
    d: "M50.71,42l-.44.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    className: "cls-41",
    d: "M48.7,42.35l-.41.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    className: "cls-41",
    d: "M49.67,42.16l-.42.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    className: "cls-41",
    d: "M44.21,45.11a.43.43,0,0,1,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    className: "cls-41",
    d: "M44.18,45.45"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    className: "cls-12",
    d: "M53,41.66c2.22-.37,3.13-.49,8.39-.49.55,0,.69.56.83,1-1.85.11-5.48.53-9,1.07C53.13,42.64,53,41.66,53,41.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-41",
    d: "M44.29,44.77l0,.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-41",
    d: "M51.83,41.82,53,41.66h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-41",
    d: "M49.25,42.24l-.55.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-41",
    d: "M44.36,44.55a1.42,1.42,0,0,0-.07.22C44.31,44.69,44.34,44.62,44.36,44.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-41",
    d: "M44.21,45.75a1.33,1.33,0,0,1,0-.28A1.33,1.33,0,0,0,44.21,45.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-41",
    d: "M50.27,42.06l-.6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_135",
    "data-name": "Path 135",
    className: "cls-41",
    d: "M51.41,41.88l-.7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    className: "cls-41",
    d: "M48.29,42.45l-.52.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    className: "cls-41",
    d: "M45.15,43.57h0l.06,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    className: "cls-41",
    d: "M44.91,43.74l-.08.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    className: "cls-41",
    d: "M44.26,44.86l-.06.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140",
    "data-name": "Path 140",
    className: "cls-41",
    d: "M44.51,44.25l-.09.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_141",
    "data-name": "Path 141",
    className: "cls-41",
    d: "M44.69,44l-.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_142",
    "data-name": "Path 142",
    className: "cls-41",
    d: "M47.36,42.7l-.48.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143",
    "data-name": "Path 143",
    className: "cls-41",
    d: "M44.2,45.17a1.27,1.27,0,0,0,0,.28A2.46,2.46,0,0,1,44.2,45.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    className: "cls-41",
    d: "M46.41,43l-.4.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    className: "cls-40",
    d: "M53.09,41.65a6.22,6.22,0,0,0,.14,1.55c-7.66,1.17-8.56,1.72-9,2.55C43.78,42.72,49.06,42.2,53.09,41.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    className: "cls-41",
    d: "M60.67,44.35l.15.82a3,3,0,0,0-2.21.68c-.76.81-.87.9-.87.9A3.46,3.46,0,0,1,60.67,44.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    className: "cls-41",
    d: "M59.84,47.66c.84,0,.8-1.53,0-1.5C59.45,46.17,59,47.68,59.84,47.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    className: "cls-41",
    d: "M60.62,54.47a2.09,2.09,0,0,1-1.86-.77,1.71,1.71,0,0,1-.19-.63.25.25,0,0,0-.29-.2.25.25,0,0,0-.2.28C58.23,54.07,59.19,54.74,60.62,54.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    className: "cls-10",
    d: "M52.35,45.9s.18,3.39-.64,3.41-2.66-1.85-2.41-3.9S51.92,43.54,52.35,45.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_150",
    "data-name": "Path 150",
    className: "cls-12",
    d: "M51.77,45.55s.45,1.33-.15,2-1.82-.81-1.2-1.94S51.62,44.77,51.77,45.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    className: "cls-33",
    d: "M42.93,42.4h0c1.88-3.06,9.91-3.09,13.68-3.15,2.08-.07,8.33-.7,8.33,1,0,.66-1.5,1.38-2.8,1.67-.1-.27-.19-.75-.75-.74-4.52.07-12.22.32-16.25,2.36a2.31,2.31,0,0,0-1,2.08,2.09,2.09,0,0,1-1.59-2.48A2,2,0,0,1,42.93,42.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    className: "cls-34",
    d: "M42.79,42.31c2.58-4.5,20.46-5,22.58-3.09.9.79-.22,2-2.3,2.49a3.34,3.34,0,0,0,1.54-1c1.72-2.71-15-1.36-19.08.12a5.06,5.06,0,0,0-2.44,1.62h0a2.2,2.2,0,0,0-.42,1.31,1.83,1.83,0,0,0,.44,1.31C41.75,44.23,42.79,42.31,42.79,42.31Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-42",
    d: "M122.18,71.54s-2.05.41-2,.6c.18.37,2.32.52,2.32.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-43",
    d: "M120.23,72.14s3.88.5,5.14-.76l6.84,38h-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-39",
    d: "M159.75,70.1s-24.45,4.57-32,4.08S119,71,119,71s-1.1,1.52,2.9,18.22,7.58,27,7.58,27L174,117.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-10",
    d: "M120.74,85.86s-1,.19-1.6,1.74S117.46,91.26,118,93s2.74,3.83,3.45,4.54,6.93-2,7-3.52-2.34.5-3.5.5,2.93-1.14,2.77-2-3.5.52-4.08.27,2-.27,2.13-1.1-3.08-.42-3.08-.42-1.28-2-.94-2.39,1.62.46,2-.43S121.78,85.12,120.74,85.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-10",
    d: "M178.64,96.81s-7.65-1.11-9.93-1.93-5.13.86-7,.49-1.05,1.47.62,1.47,3.54-.57,3.54,0-2.89.77-5,.32-2.12-.45-2.12.25,3.1,2.16,7.21,1.63c0,0,1,.18.65.49s-5-.58-6.31,0-.49,1.58,2.61,1.83,3.75,0,3.95.57-4.6-.41-4.85.37,6.4,2.24,7.62,2,8-2.07,8-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-44",
    d: "M197.93,89.42l12.26,27.34,19.54,2.52-4.46-26.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-45",
    d: "M225.26,92.49l-27.33-3.07,12.26,27.34-9.55-25.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-46",
    d: "M249.49,83.61s.62,0-.75,7.79.5,16-1.74,18.2-12.81-3-12.81-2.24-1.12,6.72-1.12,6.72,15.42,4.85,20-.75S256.21,82.11,249.49,83.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-18",
    d: "M237.74,57.93a7,7,0,0,0-3.47-1.56,6,6,0,0,0-.85,0c-.3,0-.48.08-.54.07a.5.5,0,0,1,.09-.23,4.57,4.57,0,0,1,4.52-2.56h.31a21.55,21.55,0,0,1,5.6.59,7,7,0,0,1,2.91,1.67,4.51,4.51,0,0,1,1.12,3.45c.06,2.42-.48,4.88.14,7.26a8.78,8.78,0,0,0,4,5.57,5.77,5.77,0,0,1,3,4.67,11.24,11.24,0,0,1-1.17,6.37c-1.78,3.41-5.37,1.91-5.37,1.91s2.6-1.64,2.09-2.34c0,0-2.51,3.37-4.6,3.63a5.2,5.2,0,0,1-5.14-2.27s4.68-.79,2.74-3c-1.35-1.56-1.56-3.76-3.06-6.27-.82-1.39-.07-3.74.55-6.31,0-.3.18-.83.32-1.44a10.92,10.92,0,0,0,.14-4.3,1.75,1.75,0,0,1-1,.21c-1.18-.06-1.18-.78-1.23-1.84A8.32,8.32,0,0,0,237.74,57.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-21",
    d: "M245.22,63.88a15.27,15.27,0,0,0-1.66,5c-.53,5.07,5.22,3.29,6.68,3.62a1.52,1.52,0,0,1,1.21,1.77,1.6,1.6,0,0,1-.17.46c-.41.89-1.06,1.08-1.43,1.4a1,1,0,0,0-.16,1.36.88.88,0,0,0,.25.22c1,.72,2.56-.31,2.77,1.25a3.15,3.15,0,0,1-1.29,3,3.23,3.23,0,0,0,1.65-3c-.08-1.27-.94-1.34-2.13-1.44-.73-.07-.94-.46-.84-.67.11-.43,1.15-.44,1.8-1.79a2.2,2.2,0,0,0-.57-2.79c-2.22-1.8-8.48,2.44-7.07-5A19.32,19.32,0,0,1,245.22,63.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "cls-10",
    d: "M235.43,109.72s-4.26-4.94-5-5.72-7.1-2.72-7.1-1.88.37.89,0,1.82-.74.65-.37,1.88-.15,1-.15,2,3,2.8,5.19,3.61a54.28,54.28,0,0,0,7.46,1.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "cls-3",
    d: "M59.78,2.67V12h127V2.67ZM75.54,9.22H66.45a1.52,1.52,0,0,1,0-3h9.09a1.52,1.52,0,0,1,0,3Zm104.37,0h-9.09a1.52,1.52,0,0,1,0-3h9.09a1.52,1.52,0,0,1,.08,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    className: "cls-47",
    x: 59.78,
    y: 2.67,
    width: 127.03,
    height: 1.58
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    className: "cls-3",
    x: 56.44,
    width: 132.92,
    height: 2.67
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingIllustration);
export default __webpack_public_path__ + "static/media/landing-illustration.bd2bb6fca74bee6e6cfe8ae8c8e70f79.svg";
export { ForwardRef as ReactComponent };